export default "__VITE_ASSET__DJCqgi$3__"